/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export interface ActivityDueDate {

  /**
   * Due date for the activity
   */
  dueDate?: string;
}

export class ActivityDueDate {
  dueDate?: string;

  constructor(value: ActivityDueDate) {
    this.dueDate = value?.dueDate;
  }
}
